export const STATUS = {
  CREATED: 0,
  PENDING: 1,
  COMPLETED: 2,
  CANCELLED: 10,
  CANCELLATION_REQUEST: 11,
}

export const statusLabels = {
  [STATUS.CREATED]: 'Created',
  [STATUS.PENDING]: 'Pending Cash',
  [STATUS.COMPLETED]: 'Completed',
  [STATUS.CANCELLED]: 'Cancelled',
  [STATUS.CANCELLATION_REQUEST]: 'Cancellation Request',
}

export const statusesForDropdowns = Object.entries(statusLabels)
  .map(([status, label]) => ({value: status, text: label}))

export const DEPOSIT_METHOD_TYPES = {
  CREDIT_DEBIT_CARD: 0,
  BANK_TRANSFER: 1,
  CRYPTO: 2,
  CASH: 3,
  OTHER: 4,
}
export const WITHDRAWAL_METHOD_TYPES = {
  CREDIT_DEBIT_CARD: 0,
  BANK_TRANSFER: 1,
  CRYPTO: 2,
  CASH: 3,
  OTHER: 4,
  INTERNATIONAL_BANK_TRANSFER: 5,
}